import { render, staticRenderFns } from "./EmbeddedDocumentEditView.vue?vue&type=template&id=05894b85&scoped=true&"
import script from "./EmbeddedDocumentEditView.vue?vue&type=script&lang=ts&"
export * from "./EmbeddedDocumentEditView.vue?vue&type=script&lang=ts&"
import style0 from "./EmbeddedDocumentEditView.vue?vue&type=style&index=0&id=05894b85&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05894b85",
  null
  
)

export default component.exports